export enum TRANSFER_TYPE {
  PRE_EVENT_TRANSFER = 'pre',
  DURING_EVENT_TRANSFER = 'during',
  OUTSIDE_OF_EVENT_TRANSFER = 'outside',
}

export enum TRANSFER_STATUS_VALUE {
  Null = 'null',
  New = 'new',
  Open = 'open',
  Open_draft = 'open_draft',
  Pending = 'pending',
  Canceled = 'canceled',
  Completed = 'completed',
  Void = 'void',
  Rejected = 'rejected',
}

export enum TRANSFER_STATUS_NAME {
  New = 'New',
  Open_draft = 'Open (draft)',
  Open = 'Open',
  Pending = 'Pending',
  Canceled = 'Canceled',
  Completed = 'Completed',
  Void = 'Void',
  Rejected = 'Rejected',
  NO_STATUS = '(No Status)',
}

export enum SITE_SELECT_TYPE {
  FROM = 'from',
  TO = 'to',
}
